export const TIME = {
  TEN: 10,
  FIFTEEN: 15,
  FIFTY: 50,
  HUNDRED: 100,
  HUNDRED_TEN: 110,
  HUNDRED_AND_FIFTY: 150,
  TWO_HUNDRED: 200,
  THREE_HUNDRED: 300,
  THOUSAND: 1000,
  THOUSAND_AND_FIVE_HUNDRED: 1500,
  TWO_THOUSAND: 2000,
  THREE_THOUSAND: 3000,
  FIVE_THOUSAND: 5000,
  SIXTY_THOUSAND: 60000,
};
